import { jsx as e } from "react/jsx-runtime";
import { Videocam as h, TagFaces as C, PhoneIphone as s, School as m, CheckCircle as t, DirectionsCar as l } from "@mui/icons-material";
var f = /* @__PURE__ */ ((o) => (o.CAR = "car", o.CHECK_CIRCLE = "check-circle", o.SCHOOL = "school", o.PHONE_IPHONE = "phone-iphone", o.TAG_FACES = "tag-faces", o.VIDEOCAM = "videocam", o))(f || {});
const E = {
  car: l,
  "check-circle": t,
  school: m,
  "phone-iphone": s,
  "tag-faces": C,
  videocam: h
};
function d({
  type: o,
  fontSize: i = "medium",
  color: n = "inherit",
  className: r,
  sx: a
}) {
  const c = E[o];
  return c ? /* @__PURE__ */ e(
    c,
    {
      fontSize: i,
      color: n,
      className: r,
      sx: a
    }
  ) : null;
}
export {
  d as F,
  f as a
};
